import * as React from "react";
// Keeps track of the value of an input, while maintaining it uncontrolled
// https://reactjs.org/docs/uncontrolled-components.html
export var useInputValue = function (_a) {
    var defaultValue = _a.defaultValue, valueProp = _a.value, onChangeProp = _a.onChange;
    var _b = React.useState(valueProp || defaultValue), value = _b[0], setValue = _b[1];
    var isMounting = React.useRef(true);
    React.useEffect(function () {
        if (isMounting.current) {
            isMounting.current = false;
            return;
        }
        setValue(valueProp);
    }, [valueProp]);
    var onChange = React.useCallback(function (event) {
        onChangeProp && onChangeProp(event);
        setValue(event.target.value);
    }, [onChangeProp]);
    return { value: value, onChange: onChange };
};
//# sourceMappingURL=useInputValue.js.map